var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sage-export-conflicts-dialog-container" },
    [
      _c(
        "div",
        { staticClass: "sage-export-conflicts-body" },
        [
          _c(_setup.StaticAlertComponent, {
            attrs: { alert: _setup.errorAlert },
          }),
          _c("p", { staticClass: "sage-export-conflicts-subtitle" }, [
            _vm._v(_vm._s(_setup.texts.subtitle)),
          ]),
          _c("p", { staticClass: "sage-export-conflicts-message" }, [
            _vm._v(_vm._s(_setup.texts.message)),
          ]),
          !_setup.sageConflictsGridColumns
            ? _c(_setup.SpinnerLayerComponent)
            : _c(_setup.SimpleGridTableComponent, {
                attrs: {
                  columns: _setup.sageConflictsGridColumns,
                  itemsData: _setup.conflicts,
                  paginationPageSize: _setup.PAGE_SIZE,
                  title: _setup.texts.gridTitle,
                  showGrid: true,
                  showButtons: false,
                },
              }),
        ],
        1
      ),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          showSecondaryButton: false,
          primaryButtonText: _setup.texts.primaryButtonText,
          mainAction: _setup.closeDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }